import { createCalendarVisitSchedule } from '../calendarVisitSchedule.schema';

export const normalizeCalendarVisitScheduleCooperative = calendarVisitSchedule => {
  const byPadVisitId = {};

  const id = calendarVisitSchedule.padVisitId;

  if (id) {
    byPadVisitId[id] = createCalendarVisitSchedule(calendarVisitSchedule);
  }

  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};
